export const zoomToRadius = (zoom: number) => {
    const zoomRound = Math.round(zoom)
    switch (zoomRound) {
        case 14:
        case 13:
        case 12:
        case 11:
            return 10
        case 10:
            return 20
        case 9:
            return 40
        case 8:
            return 80
        case 7:
            return 160
        case 6:
            return 320
        case 5:
            return 640
        // case 4:
        //     return 60
        // case 3:
        //     return 120
        // case 2:
        //     return 240
        // case 1:
        //     return 480
        default:
            return 640
    }
}

export const roundingDistance = (distance: number): number => {
    if (distance < 1) return Math.round(distance * 100) * 10
    if (distance >= 1 && distance < 10) return Math.round(distance * 10) / 10
    return Math.round(distance)
}
